const QUICK_LINKS_API_URL = process.env.QUICK_LINKS_API_URL;
const QUICK_LINKS_SETTINGS_URL = `${QUICK_LINKS_API_URL}/v1/settings`;

export {
    QUICK_LINKS_API_URL,
    QUICK_LINKS_SETTINGS_URL
};



// WEBPACK FOOTER //
// ./src/api/constants.js